import { useRouter } from 'next/router'

import { NextSeo } from 'next-seo'
import Link from 'next/link'
import Layout from 'web/components/Layout'
import 'web/lib/string-utils'
import GalleryHeader from 'web/components/GalleryHeader'
import GalleryGawdItems from 'web/components/GalleryGawdItems'
import { getContractData } from 'web/lib/contract'
import Gawd from 'web/lib/gawd'
import GawdManifest from 'web/lib/gawd-manifest'

import getConfig from 'next/config'

const {
  publicRuntimeConfig: { gawdsPerPage }
} = getConfig()

export async function getStaticPaths() {
  // only pregenerate the first page
  const paths = [...Array(1).keys()].map((x, i) => {
    const pageNum = i + 1
    return { params: { page: pageNum.toString() } }
  })

  return {
    fallback: true,
    paths: paths
  }
}

export async function getStaticProps({ params }) {
  const { publicRuntimeConfig } = getConfig()

  const page = Number(params.page)
  const startIndex = (page - 1) * gawdsPerPage || 0
  const endIndex = startIndex + gawdsPerPage

  console.log(`Gallery page: generating /gallery/page/${page} (start=${startIndex} end=${endIndex})...`)

  const someGawds = await GawdManifest.forceLoadMintedGawds(startIndex, endIndex)

  let revalidate
  if (someGawds.length == 0) {
    return { notFound: true }
  }
  else {
    revalidate = 60
  }

  const contractData = await getContractData()
  const totalSupply = contractData.isLive ? contractData.totalSupply : publicRuntimeConfig.previewGawdsCount
  const pageCount = Math.ceil(totalSupply / gawdsPerPage)

  console.log(`Gallery page: page=${page} gawdsCount=${someGawds.length} revalidate=${revalidate} totalSupply=${totalSupply} pageCount=${pageCount}`)

  return {
    props: {
      page,
      gawds: someGawds.map(gawd => gawd.toJson()),
      contractData,
      pageCount,
    },
    revalidate: revalidate,
  }
}

export default function GalleryPage({ page, gawds, contractData, pageCount }) {
  const router = useRouter()

  // Convert json back to list of Gawds
  const allGawds = gawds ? gawds.map((gawd) => new Gawd(gawd)) : []

  if (router.isFallback) {
    return (
      <Layout initContractData={contractData}>
        <h1 className="text-center mt-12 text-3xl md:text-4xl">Loading new page of Gawds...</h1>
      </Layout>
    )
  }

  return (
    <>
      <NextSeo title={`Gallery ${page > 1 ? `(Page ${page})` : ''}`} />

      <Layout initContractData={contractData}>
        <div className="animate-fadeIn relative py-8">
          <GalleryHeader title="Ye Gawds" initContractData={contractData} />

          <GalleryGawdItems gawds={allGawds} />

          {/* Pagination */}
          <div className="pagination space-x-4 text-center mt-12">
            {page > 1 &&
              <Link href={`/gallery/page/${page - 1}`}>
                <a className="primaryButton primary">&larr; Previous</a>
              </Link>
            }

            {page < pageCount &&
              <Link href={`/gallery/page/${page + 1}`}>
                <a className="primaryButton">Next &rarr;</a>
              </Link>
            }

            {pageCount > 1 &&
              <p className="mt-6">
                Page {page} of {pageCount}
              </p>
            }

          </div>
        </div>

      </Layout>
    </>
  )
}
